import { Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/contexts/AuthContext";

export function PrototypesGuard() {
  const { isLoggedIn, isAccountLoading, canSeePrototypes } = useAuth();
  if (!isLoggedIn || isAccountLoading) return null;
  if (!canSeePrototypes) return <Navigate to="/demo" replace />;
  return <Outlet />;
}
